document.addEventListener('DOMContentLoaded', function () {
  const variantSelects = document.querySelector('variant-selects');
  if (!variantSelects) return;

  // Dawn bettet Varianten als JSON direkt im variant-selects Element ein
  const variantData = variantSelects.querySelector('[type="application/json"]');
  if (!variantData) return;

const parsed = JSON.parse(variantData.textContent);
const variants = Array.isArray(parsed) ? parsed : (parsed.variants || parsed.product?.variants || []);

  function filterSwatches() {
    const fieldsets = variantSelects.querySelectorAll('fieldset');
    if (fieldsets.length < 3) return;

    const mat   = fieldsets[0].querySelector('input[type=radio]:checked')?.value;
    const size  = fieldsets[1].querySelector('input[type=radio]:checked')?.value;

    const colorFieldset = fieldsets[2];
    colorFieldset.querySelectorAll('input[type=radio]').forEach(input => {
      const color = input.value;
      const exists = variants.some(v =>
        v.option1 === mat &&
        v.option2 === size &&
        v.option3 === color
      );
      const li = input.closest('li');
      if (li) li.style.display = exists ? '' : 'none';
    });
  }

  variantSelects.addEventListener('change', filterSwatches);
  filterSwatches();
});
